import { InjectionToken, type Provider } from '@angular/core';

/**
 * Cross-cutting configuration for `@shared` features (notifications, future HTTP helpers, etc.).
 * Extend with optional fields as new building blocks need shared inputs.
 */
export interface SecurepaySharedConfig {
  /**
   * SecurePay HTTP API root without a trailing slash (same value as app `environment.baseAPI`).
   */
  apiBaseUrl: string;
  /**
   * Whether the app is running against the production environment (same value as app `environment.production`).
   */
  production: boolean;
}

export const SECUREPAY_SHARED_CONFIG = new InjectionToken<SecurepaySharedConfig>(
  'SECUREPAY_SHARED_CONFIG',
);

function normalizeConfig(config: SecurepaySharedConfig): SecurepaySharedConfig {
  return {
    ...config,
    apiBaseUrl: config.apiBaseUrl.replace(/\/+$/, ''),
  };
}

/**
 * Registers {@link SecurepaySharedConfig} for injection anywhere in `@shared`.
 */
export function provideSecurepaySharedConfig(
  config: SecurepaySharedConfig,
): Provider {
  return {
    provide: SECUREPAY_SHARED_CONFIG,
    useValue: normalizeConfig(config),
  };
}
